import Service from '@ember/service';
import config from 'sh-www/config/environment';
import url from 'url';
const {parse} = url;

/**
 * Regexes for the different video thumbnail formats we'll support
 */
const RE_VIMEO = /^(?:\/video|\/channels\/[\w-]+|\/groups\/[\w-]+\/videos)?\/(\d+)$/;
const RE_YOUTUBE = /^(?:\/embed)?\/([\w-]{10,12})$/;
// const RE_FACEBOOK = /^\/[\w-]+\/videos\/(\d+)(\/)?$/;

export default Service.extend({
  /**
   * Cloud name from Cloudinary
   */
  get _cloudinaryCloudName() {
    return config.cloudinary.cloudName;
  },

  /**
   * Given a url, try to get a thumbnail if we support that format.
   *
   * @param {String} url
   * @return {String|null}
   */
  getThumb(url) {
    url = url || '';


    if (!url.match(/^https?:\/\//)) {
      url = 'https://' + url;
    }

    let urlobj;

    try {
      urlobj = parse(url, true);
    } catch (error) {
      return null;
    }

    //youtube
    if (['www.youtube.com', 'youtube.com', 'youtu.be'].indexOf(urlobj.host) !== -1) {
      let video_id = null;
      if ('v' in urlobj.query) {
        if (urlobj.query.v && urlobj.query.v.match(/^[\w-]{10,12}$/)) {
          video_id = urlobj.query.v;
        }
      } else {
        const match = RE_YOUTUBE.exec(urlobj.pathname);
        if (match) {
          video_id = match[1];
        }
      }

      if (video_id) {
        // https://res.cloudinary.com/ddsqycvoq/image/vimeo/1234
        return  `https://res.cloudinary.com/${this.get('_cloudinaryCloudName')}/image/youtube/${video_id}`;
      }
    }

    //vimeo
    if (['www.vimeo.com', 'vimeo.com', 'player.vimeo.com'].indexOf(urlobj.host) !== -1) {
      const match = RE_VIMEO.exec(urlobj.pathname);
      if (match) {
        const video_id = match[1];
        return `https://res.cloudinary.com/${this.get('_cloudinaryCloudName')}/image/vimeo/${video_id}`;
      }
    }

    //facebook
    // if (['facebook.com', 'www.facebook.com'].indexOf(urlobj.host) !== -1) {
    //   const match = RE_FACEBOOK.exec(urlobj.pathname);
    //
    //   if (match) {
    //     const video_id = match[1];
    //     return
    //   }
    // }

    return null;
  }
});
